import { useState } from "react"
import styled from "@emotion/styled"

import AlertBanner from "../ui/alert-banner"
import IconTransfer from "../ui/images/icon-bank-transfer"
import VisaMastercard from "../ui/images/visa-mastercard"
import PayBox from "./pay-box"

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
`

const Title = styled.h4`
  color: #1f2425;
  text-align: center;
  line-height: 140%;
`

const ContainerPayOnline = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`


const PayOnlineMx = () => {
  const [showOtherOptions, setShowOtherOptions] = useState(false)

  const toggleOtherOptions = () => {
    setShowOtherOptions(!showOtherOptions)
  }

  return (
    <Content>
      <Title>
        Depósito con tu tarjeta de crédito o Transferencia electrónica
      </Title>

      <ContainerPayOnline>
        <PayBox
          event="transfer"
          url="https://onboarding.capitaria.com/deposit"
          tax="*Tarifa 2% + USD 1"
        >
          <IconTransfer />
        </PayBox>
        <PayBox
          event="onboarding"
          url="https://onboarding.capitaria.com/deposit"
          tax="*Tarifa 3%"
        >
          <VisaMastercard />
        </PayBox>
      </ContainerPayOnline>

      <AlertBanner>
        <strong>IMPORTANTE:</strong> Al realizar un depósito con tarjeta de
        crédito o transferencia electrónica, este tiene un costo de 3% con
        tarjeta de crédito y 2% + USD 1 con transferencia electrónica. Dicho costo
        será descontado del monto depositado.
        <br />
        <br />
        <strong>
          NO SE ACEPTAN PAGOS PROVENIENTES DE TARJETAS DE TERCEROS NI CUENTAS
          DE TERCEROS.
        </strong>{" "}
        Si esto sucede, el pago será anulado.
      </AlertBanner>
    </Content>
  )
}

export default PayOnlineMx
